///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/editors/date/datepickerDefaults"/>
import * as culture from "Core/Medius.Core.Web/Scripts/Medius/lib/culture";

export = {
    todayHighlight: true,
    autoclose: true,
    forceParse: false,
    language: culture.getCode()
};